<lib-generic-message-box
  [messageType]="hasInstalmentPlan ? messageBoxTypeInfo : messageBoxTypeError"
  id="'error'"
  *ngIf="messageBoxTitle"
>
  <ng-container Title>{{ messageBoxTitle }}</ng-container>

  <p
    *ngIf="messageBoxContent && !hasInstalmentPlan"
    data-tms-event="card-click-impression"
    data-tms-card-zone="mybill.overview"
    attr.data-tms-card-name="{{
      hasPaymentRefused ? 'refused direct debit' : 'payment overdue'
    }}"
    attr.data-cy="{{
      hasPaymentRefused
        ? 'myBillPopCardTextPaymentOverdueRefusedDD'
        : 'myBillPopCardTextPaymentOverdueNotDD'
    }}"
    Content
  >
    {{ messageBoxContent }}
  </p>

  <p Content *ngIf="messageBoxContent && hasInstalmentPlan">
    <span>
      {{ messageBoxContent }}
      <ng-container *ngIf="billingDocument">
        <div class="rs-me"></div>
        <my-bill-pdf-document
          [customerId]="customerId"
          [buttonZone]="'mybill.overview'"
          [paId]="billingAccount.accountNumber"
          [documentId]="billingDocument.reference"
          [documentDate]="billingDocument.documentDate"
        ></my-bill-pdf-document>
      </ng-container>
    </span>
  </p>
</lib-generic-message-box>
<my-bill-pdf-error-overlayer></my-bill-pdf-error-overlayer>
